/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CsszDistrictListSchema } from '../models/CsszDistrictListSchema';
import type { ESickNoteCaseKind } from '../models/ESickNoteCaseKind';
import type { PagedESickNoteCaseListItemSchema } from '../models/PagedESickNoteCaseListItemSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EsickNotesApi {
    /**
     * Get Cssz District List
     * List the ČSSZ districts (číselník okresů): an IČPE is registered under one, and its code is sent as KodSSZ / KodOssz in every podání. Returns the whole codelist unpaginated. Required Permission: create_esick_note
     * @returns CsszDistrictListSchema OK
     * @throws ApiError
     */
    public static esickNoteGetCsszDistrictListGet({
        search,
    }: {
        search?: (string | null),
    }): CancelablePromise<Array<CsszDistrictListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/cssz-districts/',
            query: {
                'search': search,
            },
        });
    }
    /**
     * Get Esick Note Case List
     * List DPN, ošetřovné and dlouhodobé ošetřovné cases of the logged-in user's company in one feed, newest first. Each row's kind says which endpoints handle the case. Required Permission: create_esick_note
     * @returns PagedESickNoteCaseListItemSchema OK
     * @throws ApiError
     */
    public static esickNoteGetEsickNoteCaseListGet({
        patientId,
        kind,
        limit = 100,
        offset,
    }: {
        patientId?: (string | null),
        kind?: (ESickNoteCaseKind | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedESickNoteCaseListItemSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/cases/',
            query: {
                'patient_id': patientId,
                'kind': kind,
                'limit': limit,
                'offset': offset,
            },
        });
    }
}
